import React from "react"
import AuthCodeForm from "../../forms/auth/AuthCodeForm";
import {storeLoginToken, storeSupportUserCode} from "../../helpers/authHelper";
import {isNotEmpty} from "../../helpers/functions";

interface IAuthCodeProps{
    handleSection: any,
    mobile: string,
}

const AuthCode: React.FC<IAuthCodeProps> = ({handleSection, mobile}) => {

    const handleLoginUser = (token:string, code:string) => {
        if((typeof token !== 'undefined' && isNotEmpty(token)) && (typeof code !== 'undefined' && isNotEmpty(code))){
            storeLoginToken(token)
            storeSupportUserCode(code)
            window.location.replace("/dashboard/users/list")
        }
    }

    return (
        <React.Fragment>
            <AuthCodeForm handleSection={handleSection} mobile={mobile} handleAfterLoginUser={handleLoginUser} />
        </React.Fragment>
    )
}

export default AuthCode